import Vue from 'vue'
import firebase from '@/firebase'
import {parseDocumentsToObject,parseDocument} from '@/utils/populations'


export default {
  namespaced: true,
  state: {
    loading: false,
    error: null,
    items: {}
  },
  actions: {
    async initialize ({commit}) {
      console.log('reserves initialize')
      commit('LOADING', true)
      firebase.firestore.collection('reserves').orderBy('name').onSnapshot(
        (result) => {
          const itemsObj = parseDocumentsToObject(result.docs)
          commit('ON_SNAPSHOT', itemsObj)
          for (const key in itemsObj) {
            const doc = itemsObj[key];
            const docRef = firebase.firestore.collection('reserves').doc(doc.id)
            docRef.collection('trees').onSnapshot(
              (result2) => commit('UPDATE_TREES', [key, parseDocumentsToObject(result2.docs)]),
            )
            docRef.collection('seeds').onSnapshot(
              (result3) => commit('UPDATE_SEEDS', [key, result3.docs.map(parseDocument)]),
            )
          }
        },
        (err) => commit('ERROR', err)
      )
    }
  },
  mutations: {
    LOADING (state, loading) {
      Vue.set(state, 'loading', loading)
    },
    ON_SNAPSHOT (state, items = {}) {
      Vue.set(state, 'items', items)
      Vue.set(state, 'loading', false)
    },
    ERROR (state, error) {
      console.error(error)
      Vue.set(state, 'error', error)
      Vue.set(state, 'loading', false)
    },
    UPDATE_TREES (state, [key, trees = []]) {
      Vue.set(state.items[key], 'trees', trees)
    },
    UPDATE_SEEDS (state, [key, seeds = []]) {
      Vue.set(state.items[key], 'seeds', seeds)
    }
  }
}


// WEBPACK FOOTER //
// ./src/store/reserves.js